import React, {useEffect, useState} from 'react';
import style from "./REG300F1.module.scss";
import styleCom from "./REGCOM.module.scss";
import DataGrid from "../../components/DataGrid/DataGrid";
import RadioGroup from "../../components/Radio/RadioGroup";

const REG300M1 = ({handle_Close, autoCheckObj, activeTabId, comHandleClick_Save}) => {

    const [contentId, setContentId] = useState(activeTabId);
    //const autoListObj = autoCheckObj;
    const autoListObj = [...autoCheckObj].sort((a, b) => {
        return (
          a.contentId.localeCompare(b.contentId) ||   // 1순위: id 비교
          a.sno.localeCompare(b.sno) ||
          a.category.localeCompare(b.category) || // 2순위: id가 같으면 Nm1 비교
          a.note.localeCompare(b.note)    // 3순위: Nm1까지 같으면 Nm2 비교
        );
    });
    //Query 등록팝업 호출(제목)


    const [rows_mstList, setRows_mstList] = useState([]);
    const cols_mstList = [
        { key: 'contentNm', name: '분류-1',  width: '20%'},
        { key: 'category',  name: '분류-2',  width: '30%'},
        { key: 'note',      name: '항목',  width: '50%' }
    ];

    //폼 로드
    useEffect(() => {

        loadQueryList(contentId);
    }, []);



    const loadQueryList = (tarContentId="") => {
        const checkDataObj = autoListObj.map(item => {
            let titleValue;
            switch (item.contentId) {
                case 'T1':  titleValue = "Admission"; break;
                case 'T12': titleValue = "Lab Data"; break;
                case 'T2':  titleValue = "CAG"; break;
                case 'T3':  titleValue = "1st Lesion"; break;
                case 'T4':  titleValue = "2nd Lesion"; break;
                case 'T5':  titleValue = "3rd Lesion"; break;
                case 'T6':  titleValue = "4th Lesion"; break;
                case 'T7':  titleValue = "Discharge"; break;
                case 'T8':  titleValue = "1M FU"; break;
                case 'T9':  titleValue = "6M FU"; break;
                case 'T10': titleValue = "12M FU"; break;
                case 'T11': titleValue = "FU Angiography"; break;
                case 'T13': titleValue = "Clinical Event"; break;
                case 'T99': titleValue = "End of Study"; break;
                default: titleValue = '';
            }

            return {
                ...item,
                contentNm: titleValue
            };
        });

        if(tarContentId !== "T0" && tarContentId !== null && tarContentId !== ""){
            const resultObj = checkDataObj.filter(item =>
              item.contentId === tarContentId
            )
            setRows_mstList(resultObj);
        }else{
            setContentId("");
            setRows_mstList(checkDataObj);
        }
        //console.log(checkDataObj);
        //setRows_mstList(checkDataObj);

    }

    const onClick_contentId = (value) => {
        setContentId(value);
        loadQueryList(value);
    }


    return (
        <main height={"800px"}>
            <div className={style.search_table}
                 style={{height: "72px", marginBottom: "10px", width:"100%"}}>
                <div style={{marginTop:"10px"}}>
                    <RadioGroup colCnt={8} marginLeft={"10px"}
                                options={
                                    [  {mapCd: '',  value: "",  label: "전체"}
                                        ,{mapCd: 'T1',  value: "T1",  label: "Admission"}
                                        ,{mapCd: 'T12', value: "T12", label: "Lab Data"}
                                        ,{mapCd: 'T2',  value: "T2",  label: "CAG"}
                                        ,{mapCd: 'T3',  value: "T3",  label: "1st Lesion"}
                                        ,{mapCd: 'T4',  value: "T4",  label: "2nd Lesion"}
                                        ,{mapCd: 'T5',  value: "T5",  label: "3rd Lesion"}
                                        ,{mapCd: 'T6',  value: "T6",  label: "4th Lesion"}
                                        ,{mapCd: 'T7',  value: "T7",  label: "Discharge"}
                                        ,{mapCd: 'T8',  value: "T8",  label: "1M FU"}
                                        ,{mapCd: 'T9',  value: "T9",  label: "6M FU"}
                                        ,{mapCd: 'T10', value: "T10", label: "12M FU"}
                                        ,{mapCd: 'T11', value: "T11", label: "FU Angiography"}
                                        ,{mapCd: 'T13', value: "T13", label: "Clinical Event"}
                                        ,{mapCd: 'T99', value: "T99", label: "End of Study"}
                                    ]
                                }
                                selectedValue={contentId}
                                onChange={(val) => onClick_contentId(val)}

                    />
                </div>

            </div>
            <div className={styleCom.main_wrap} style={{height: "600px"}}>
                <div width={"100%"} style={{height:"100%", overflowY:"auto"}}>
                    <DataGrid
                        cols={cols_mstList}
                        rows={rows_mstList}
                        rowHeight={38}
                        // onCellDoubleClick={(e) => handleDoubleClick_DataGrid_row(e)}
                        //onCellClick={(e) => handleClick_mstGrid_row(e)}
                        sortable={true}
                        isNodataView={true}
                    />
                </div>

            </div>
        </main>


    )
}
export default REG300M1;